import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {

  initialize() {
    this.timeout = null;
    if (this.element.dataset.value == "opened") {
      document.querySelector('a[href="#related"]').click();
    }
  }

  connect() {
    this.element.addEventListener("accordion:opened", () => this.storeCache("opened"));
    this.element.addEventListener("accordion:closed", () => this.storeCache("closed"));
  }

  disconnect() {
    this.element.removeEventListener("accordion:opened", () => this.storeCache("opened"));
    this.element.removeEventListener("accordion:closed", () => this.storeCache("closed"));
  }

  storeCache(value) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      Rails.ajax({
        type: 'GET',
        url: `/users/store_data?value=${value}`,
        success: () => {},
        error: () => {
          alert('Произошла ошибка!');
        },
      });
    }, 500);
  }
}
